import React, { useState ,useEffect} from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';
import N from '../lib/Network'
import AC from '../lib/AppConsts'
import S from '../lib/Security'
import swal from 'sweetalert'
import Loader from './Loader'
var CryptoJS = require("crypto-js");

const EditUser = ({ showUserPopupEdit, closeEditModal,oldRecord }) =>  {
    const [employeeID,setEmployeeID]=useState('');
    const [employeeName,setEmployeeName]=useState('');
    const [emailID,setEmailID]=useState('');
    const [contactNo,setContactNo]=useState('');
    const [status,setStatus]=useState('');
    const [errors,setErrors] = useState({});
    const [roleData,setRoleData] = useState('');
    const [role,setRole] = useState([ ]);
    const [edit,setEdit] = useState({ });
    const [useId,setUserId] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    var selopt =[];
    useEffect(() => {
        getKeys();
        fetchRoleData();
        if(oldRecord?.oldData?.UserId){
            findByUserData();
        }
        
    },[])
    const showLoaderPopup = () => { setShowLoader(true) }
    const closeLoader = () => { setShowLoader(false) }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const closePopup = () => { closeEditModal(); clearState(); }
    const fetchRoleData = () => {
        N.getApi('getRoles')
        .then(res => {
            var response = S.getDecryptedJSON(res);
           setRoleData(JSON.parse(response.responseJson))
          })
      }
      var [user] = useState()
      var editdata='';
      const findByUserData = () => {
        user = {
            userId:oldRecord?.oldData?.UserId
        };
        N.postApi('getUserById',user)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            var editeddata=JSON.parse(response.responseJson);
            editdata=editeddata.Payload.userData;
            setEmployeeID(editdata[0].empCode)
            setEmployeeName(editdata[0].UserFullName)
            setContactNo(editdata[0].contactNo)
            setStatus(editdata[0].userStatus)
            setEmailID(editdata[0].empEmail)
            setRole(JSON.parse(editdata[0].role))
            setUserId(editdata[0].userId)
        })
        .catch(err => {
            console.log("Error : "+err);
        });
      }
    const validateForm = () => {
        let formIsValid = true;
        let err = {};
        var alphaNumeric = new RegExp(/^[A-Za-z0-9]+$/i);
        var alphawithspace = new RegExp(/^[A-Za-z ]+$/i);
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        var PhPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);
        if(employeeID ==="" ){
          err["employeeID"] = "Employee ID cannot be empty";
          formIsValid= false;
        }else if(!alphaNumeric.test(employeeID)){
            err["employeeID"] = "Special character not allowed in Employee ID";
          formIsValid= false;
        }if(employeeName ==="" || employeeName.length<=0  ){
            err["employeeName"] = "Employee Name cannot be empty";
            formIsValid= false;
        }else if(!alphawithspace.test(employeeName)){
            err["employeeName"] = "Special character and Numeric value are not allowed in Employee Name";
          formIsValid= false;
        }if(emailID ==="" || emailID.length<=0){
            err["emailID"] = "Email ID cannot be empty";
            formIsValid= false;
        }else if(!pattern.test(emailID)){
            err["emailID"] = "Please enter valid email address.";
            formIsValid= false;
        }
        if(contactNo ===""){
            err["contactNo"] = "Contact No cannot be empty";
            formIsValid= false;
            
        }else if(!PhPattern.test(contactNo)){
            err["contactNo"] = "Please enter valid Contact No ";
            formIsValid= false;
        }else if(contactNo.length!= 10){
            err["contactNo"] = "Please enter valid Contact No";
            formIsValid= false;
        }
        if(status ==="" || status ===undefined){
            err["status"] = "status cannot be empty";
            formIsValid= false;
        }if(role.length<=0){
            err["role"] = "select at least one role";
            formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }

    const validateEmpName = (event) =>{
        var employeenameValidate = {
        empName: event.target.value,
        userId:useId
        }
        if(employeenameValidate.empName.length != 0){
            N.postApi('validateManageUser', employeenameValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["employeeName"] = msg.Payload.Message;
                        setErrors(er);
                }}
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors('');
        }
    }
    const validateEmpID = (event) =>{
        var employeecodeValidate = {
            empCode: event.target.value,
            userId:useId
        }
        if(employeecodeValidate.empCode.length != 0){
            N.postApi('validateManageUser', employeecodeValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["employeeID"] = msg.Payload.Message;
                        setErrors(er);
                }}  
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors('');
        }
    }
    const validateEmpEmail = (event) =>{
        var employeeEmailValidate = {
            empEmail: event.target.value,
            userId:useId
        }
        if(employeeEmailValidate.empEmail.length != 0){
            N.postApi('validateManageUser', employeeEmailValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["emailID"] = msg.Payload.Message;
                        setErrors(er);
                }}  
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors('');
        }
    }

    const handleChange = (event) => {
        console.log("event.target.name"+event.target.name);
        console.log("event.target.value"+event.target.value);
        if (event.target.name === 'employeeID') {
            errors["employeeID"] ="";
            setEmployeeID( event.target.value );
        }
        if (event.target.name === 'employeeName') {
            errors["employeeName"] ="";
            setEmployeeName( event.target.value );
        }
        if (event.target.name === 'emailID') {
            errors["emailID"] ="";
            setEmailID( event.target.value );
        }
        if (event.target.name === 'contactNo') {
            errors["contactNo"] ="";
            setContactNo( event.target.value );
        }
        if (event.target.name === 'status') {
            if(event.target.value != 0){
                errors["status"] ="";
                setStatus( event.target.value )
            }else{
            errors["status"] ="";
            setStatus();
            }
        }
    }
    
    const onSelect =  (data) => { errors["role"] = ""; setRole(data); }
    const onRemove =  (data) => { errors["role"] = ""; setRole(data); }
    const updateUserDetails = (event) => {
        event.preventDefault()
        if(validateForm()){
            if (Object.keys(errors).length === 0) {
            showLoaderPopup();
            var TabObj = {
                role :role,
                userStatus :status,
                empName :employeeName,
                empCode : employeeID,
                empEmail : emailID,
                contactNo : contactNo,
                action : AC.ACTION_UPDATE,
                createdById : localStorage.getItem("userId"),
                userCreatedDate : date,
                userId : useId,
            }
            return N.postApi('updateUser',TabObj)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus === AC.STATUS_SUCCESS){
                    closeLoader();
                    swal("Success!", "Record Saved Suceesfully", "success", { buttons: false,timer: 2000,});
                    closePopup();
                    setTimeout(() => {
                        window.location.reload(true); 
                    }, 2000);
                }else{
                    closeLoader();
                    swal("Error!", "Record Not Saved", "warning", { buttons: false,timer: 2000,});
                    document.getElementById("updateUser").disabled = false;
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    }
    const clearState = () =>{ setRole([]); setStatus(''); setEmployeeName(); setEmployeeID('');  setEmailID(''); setContactNo(''); setErrors({});}
    return (
        <Modal id="addUser" show={showUserPopupEdit}  animation={true}  size="xl">
            <Modal.Header closeButton onClick={closePopup}>
                <Modal.Title><h5 className="headerTitle">Update User</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Employee ID</Form.Label>
                                <Form.Control  name="employeeID" type="text" defaultValue={employeeID}  className="form-control" placeholder="Enter Employee ID" onBlur={handleChange} onKeyUp={validateEmpID} />
                                <div className="invalid-feedback">{errors["employeeID"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Employee Name</Form.Label>
                                <Form.Control  type="text" name="employeeName" defaultValue={employeeName} className="form-control" placeholder="Enter Employee Name" onBlur={handleChange} onKeyUp={validateEmpName}/>
                                <div className="invalid-feedback">{errors["employeeName"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email ID</Form.Label>
                                <Form.Control  type="text" name="emailID" className="form-control" defaultValue={emailID} placeholder="Enter Email ID" onBlur={handleChange} onKeyUp={validateEmpEmail} readOnly/>
                                <div className="invalid-feedback">{errors["emailID"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Contact No.</Form.Label>
                                <Form.Control  type="number" name="contactNo" className="form-control" defaultValue={contactNo} placeholder="Enter Contact No." onKeyUp={handleChange} />
                                <div className="invalid-feedback">{errors["contactNo"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Select name="status" className="form-control" value={status}  onChange={handleChange}>
                                    <option value="0" >- Select User Status -</option>
                                    <option value="Y">Active</option>
                                    <option value="N">Inactive</option>
                                </Form.Select>
                                <div className="invalid-feedback">{errors["status"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={6} lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Roles</Form.Label>   
                                <Multiselect
                                    name='role'
                                    options={roleData?.Payload?.RoleList}
                                    displayValue='roleName'
                                    onSelect={onSelect}
                                    onRemove={onRemove}
                                    selectedValues={role}
                                    />
                                <div className="invalid-feedback">{errors["role"]}</div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
                <Loader showLoader={showLoader} />
            </Modal.Body>
            <Modal.Footer className='text-center'>
                <Button className="btn btn-sm btn-danger shadow-sm" onClick={closePopup}> Cancel </Button>
                <Button type="button" className="btn btn-sm btn-primary shadow-sm" id="updateUser" onClick={updateUserDetails}> Update </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default EditUser;